module.exports = __webpack_public_path__ + "img/complete-primary.07ec62ee.svg";